import { useEffect } from 'react';
import { BackHandler } from 'react-native';

export const useBackHandler = (customBackAction?: () => void) => {
  useEffect(() => {
    const backAction = () => {
      if (customBackAction) {
        customBackAction();
      }
      return true;
    };

    const backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      backAction,
    );

    return () => {
      backHandler.remove();
    };
  }, [customBackAction]);
};
